import React from 'react'

type Props = {}

const TopDevelopers = (props: Props) => {
  return (
    <div className='me-5'>
      <div className='card'>
        <div className='card-body d-flex flex-center flex-column pt-12 p-9'>
          <div className='symbol symbol-65px symbol-circle mb-5'>
            <img
              src='https://preview.keenthemes.com/metronic8/demo5/assets/media//avatars/300-1.jpg'
              alt='user'
            />
            <div className='bg-success position-absolute  badge badge-success border-white rounded translate-middle start-100 top-100 ms-n3 mt-n3'>
              {' '}
              <small>pro</small>
            </div>
          </div>

          <a href='#' className='fs-4 text-gray-800 text-hover-primary fw-bolder mb-0'>
            John Doe
          </a>

          <div className='fw-bold text-gray-400 mb-6'>Full Stack developer</div>

          <div className='d-flex flex-center flex-wrap'>
            <div className='border border-gray-300 border-dashed rounded min-w-80px py-3 px-4 mx-2 mb-3'>
              <div className='fs-6 fw-bolder text-gray-700'>$14,560</div>
              <div className='fw-bold text-gray-400'>Earnings</div>
            </div>

            <div className='border border-gray-300 border-dashed rounded min-w-80px py-3 px-4 mx-2 mb-3'>
              <div className='fs-6 fw-bolder text-gray-700'>23</div>
              <div className='fw-bold text-gray-400'>Projects</div>
            </div>
          </div>
          <div className='row'>
            <div className='col-auto'>
              {' '}
              <span className='badge badge-primary btn-outline btn-secondary rounded  my-1 '>
                Node js
              </span>
            </div>
            <div className='col-auto'>
              {' '}
              <span className='badge badge-primary btn-outline btn-secondary rounded  my-1 '>
                React js
              </span>
            </div>
            <div className='col-auto'>
              {' '}
              <span className='badge badge-primary btn-outline btn-secondary rounded  my-1 '>
                Mongo DB
              </span>
            </div>
            <div className='col-auto'>
              {' '}
              <span className='badge badge-primary btn-outline btn-secondary rounded  my-1 '>
                Flutter
              </span>
            </div>
            <div className='col-auto'>
              {' '}
              <span className='badge badge-info btn-outline btn-secondary rounded  my-1 '>+3</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TopDevelopers
